import React from 'react';
import { Edit } from 'react-admin';
import { getTransform } from '../rateSettingsTransform';
import RateSettingsForm from '../shared/rate-settings-form/RateSettingsForm';
const MarketRateSettingEdit = () => (
  <Edit mutationMode="pessimistic" transform={getTransform(['market_id'], 'market_rate_setting')}>
    <RateSettingsForm settingsField="market_rate_setting" />
  </Edit>
);

export default MarketRateSettingEdit;
